export default {
  getFavoriteRoutes(params, skipLoading) {
    return Vue.http.get('topology/routes/client_favorites', {params, skipLoading}).then(
      response => response.data.data
    )
  },

  getRoutes(params, skipLoading) {
    return Vue.http.get('topology/routes', {params, skipLoading}).then(
      response => response.data.data
    )
  },

  getIncidences(params) {
    return Vue.http.get('tracking/incidences',
      {params, skipLoading: true, noCache: true}).then(response => response.data.data)
  },

  getStops(params, skipLoading) {
    return Vue.http.get('topology/stops', {params, skipLoading}).then(
      response => response.data.data
    )
  },

  getRoute(id, params = {}) {
    return Vue.http.get(`topology/routes/${id}`, {params}).then(response => response.data)
  }
}